(function () {
  'use strict';

  var revealObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        el.classList.add('revealed');

        if (el.getAttribute('data-reveal') === 'stagger') {
          Array.from(el.children).forEach(function (child, i) {
            child.style.transitionDelay = i * 120 + 'ms';
            child.classList.add('revealed');
          });
        }

        revealObserver.unobserve(el);
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );

  function initReveals() {
    document.querySelectorAll('[data-reveal]').forEach(function (el) {
      el.classList.add('reveal');
      revealObserver.observe(el);
    });
  }

  // Counter animation for elements with data-count-to
  var counterObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseInt(el.getAttribute('data-count-to'), 10);
        var duration = 1500;
        var start = performance.now();

        function step(now) {
          var progress = Math.min((now - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          el.textContent = Math.round(eased * target);
          if (progress < 1) requestAnimationFrame(step);
        }

        requestAnimationFrame(step);
        counterObserver.unobserve(el);
      });
    },
    { threshold: 0.5 }
  );

  function initCounters() {
    document.querySelectorAll('[data-count-to]').forEach(function (el) {
      counterObserver.observe(el);
    });
  }

  // Horizontal scroll parallax helper
  function initParallaxScroll() {
    document.querySelectorAll('[data-parallax-scroll]').forEach(function (container) {
      var track = container.querySelector('[data-parallax-track]');
      if (!track) return;

      window.addEventListener('scroll', function () {
        var rect = container.getBoundingClientRect();
        var vh = window.innerHeight;
        if (rect.bottom < 0 || rect.top > vh) return;
        var progress = (vh - rect.top) / (vh + rect.height);
        var shift = (progress - 0.5) * 60;
        track.style.transform = 'translateX(' + shift + 'px)';
      }, { passive: true });
    });
  }

  // ECG line draw animation
  var ecgObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('why-pulse__ecg--animate');
        ecgObserver.unobserve(entry.target);
      });
    },
    { threshold: 0.3 }
  );

  function initEcg() {
    document.querySelectorAll('.why-pulse__ecg').forEach(function (el) {
      ecgObserver.observe(el);
    });
  }

  // Drag-to-scroll for horizontal scroll areas
  function initDragScroll() {
    document.querySelectorAll('.series-showcase__scroll, .color-story__track').forEach(function(el) {
      var isDown = false, startX, scrollLeft;
      el.style.cursor = 'grab';

      el.addEventListener('mousedown', function(e) {
        isDown = true; el.style.cursor = 'grabbing';
        startX = e.pageX - el.offsetLeft;
        scrollLeft = el.scrollLeft;
        e.preventDefault();
      });
      el.addEventListener('mouseleave', function() { isDown = false; el.style.cursor = 'grab'; });
      el.addEventListener('mouseup', function() { isDown = false; el.style.cursor = 'grab'; });
      el.addEventListener('mousemove', function(e) {
        if (!isDown) return;
        var x = e.pageX - el.offsetLeft;
        el.scrollLeft = scrollLeft - (x - startX) * 1.5;
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveals();
    initCounters();
    initParallaxScroll();
    initEcg();
    initDragScroll();
  });
})();
